import type { IMappingValidationResult, ISpreadsheetTemplateActive } from "../../customTypings/spreadsheetTemplate/SpreadsheetTemplate";
import { hasBlockingValidationErrors } from "./wasteReturnTemplateMappingDefaults";

export const TEST_EXPORT_BUTTON_LABEL = "Generate Test Export";

export function canGenerateTestExport(
    activeTemplate: ISpreadsheetTemplateActive | null | undefined,
    validation: IMappingValidationResult | null | undefined,
    isBusy = false
): boolean {
    return !!activeTemplate?.hasMapping && !hasBlockingValidationErrors(validation) && !isBusy;
}
